export const YOUTUBE_VERIFICATION_LINK = 'https://www.youtube.com/verify';

export const YOUTUBE_CHANNEL_NEEDED_EDUCATION_LINK =
  'https://support.google.com/youtube/answer/1646861?hl=en';

export const YOUTUBE_PLAYLIST_NAME_MAX_CHARS = 150;
